const PREFIX = 'sl.analytics';

export const enum EventNames {
	FilterClick = 'filterClick',
	FormInteraction = 'formInteraction',
	FormValidationFailed = 'formValidationFailed',
	FormSubmit = 'formSubmit',
	NetworkError = 'networkError',
	QuizStart = 'quizStart',
	QuizComplete = 'quizComplete',
	SocialShare = 'socialShare',
	SearchSubmit = 'searchSubmit',
	VideoPlay = 'videoPlay',
	VideoProgress = 'videoProgress',
	VideoStop = 'videoStop',
	VideoComplete = 'videoComplete',
}

/**
 * Dispatches a custom event on the $dispatchTarget with provided eventName and eventData.
 * @param {JQuery<HTMLElement>} $dispatchTarget the JQuery-element on which the event should be dispatched
 * @param {string} eventName the name of the event (use EventNames-enum)
 * @param {object} eventData optional eventData
 */
export function dispatchCustomEvent($dispatchTarget: JQuery<HTMLElement>, eventName: EventNames, eventData?: object) {
	polyfillCustomEvent();

	const event = new CustomEvent(`${PREFIX}.${eventName}`, {
		bubbles: true,
		detail: eventData || {},
	});

	$dispatchTarget.get(0).dispatchEvent(event);
}

/**
 * Polyfill CustomEvent for IE
 * Source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
 */
function polyfillCustomEvent() {
	if (typeof (window as any).CustomEvent === 'function') {
		return;
	}

	function CustomEvent(event, params) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		const evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		return evt;
	}

	CustomEvent.prototype = (window as any).Event.prototype;

	(window as any).CustomEvent = CustomEvent;
}
